// src/components/WhyChoose/WhyChoose.tsx
import React from 'react';
import './WhyChoose.css';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

const WhyChoose: React.FC = () => {
  const benefits: Benefit[] = [
    {
      icon: '⭐',
      title: '15+ Years Experience',
      description: 'Certified astrologer with extensive knowledge in multiple astrological traditions.'
    },
    {
      icon: '🌍',
      title: 'Global Reach',
      description: 'Online consultations available worldwide with flexible scheduling options.'
    },
    {
      icon: '💎',
      title: 'Personalized Approach',
      description: 'Every reading is tailored specifically to your unique birth chart and life circumstances.'
    },
    {
      icon: '🔒',
      title: 'Confidential & Safe',
      description: 'Licensed and insured with complete confidentiality of your personal information and session details.'
    }
  ];

  return (
    <section className="why-choose">
      <div className="container">
        <h2>Why Choose Me</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;